import { Mail, Phone } from "lucide-react";

export const Footer = () => (
  <footer id="contato" className="pt-24 md:pt-32 pb-10 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-2 gap-10 mb-16">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">Vamos conversar</span>
          <h2 className="font-head font-black text-3xl md:text-5xl tracking-tight mt-4 max-w-md leading-tight">
            Pronto para impulsionar seu negócio?
          </h2>
        </div>
        <div className="flex flex-col justify-end gap-4">
          <a href="https://wa.me/5542999587464" target="_blank" rel="noreferrer" data-testid="footer-whatsapp"
             className="group flex items-center justify-between border-b border-white/15 py-4 hover:border-cobalt transition-colors duration-300">
            <span className="flex items-center gap-3 text-lg"><Phone className="w-5 h-5 text-cobalt" /> +55 42 99958-7464</span>
            <span className="font-mono text-xs text-white/40 group-hover:translate-x-1 transition-transform duration-300">WhatsApp →</span>
          </a>
          <a href="mailto:contato@jeaxlabs.com.br" data-testid="footer-email"
             className="group flex items-center justify-between border-b border-white/15 py-4 hover:border-cobalt transition-colors duration-300">
            <span className="flex items-center gap-3 text-lg"><Mail className="w-5 h-5 text-cobalt" /> contato@jeaxlabs.com.br</span>
            <span className="font-mono text-xs text-white/40 group-hover:translate-x-1 transition-transform duration-300">E-mail →</span>
          </a>
        </div>
      </div>

      <div className="py-4">
        <img src="/logo-full.png" alt="JeaxLabs" className="w-full max-w-md md:max-w-lg h-auto opacity-95" />
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mt-10 pt-8 border-t border-white/10">
        <span className="font-mono text-xs text-white/40">© {new Date().getFullYear()} JeaxLabs · Soluções em Software</span>
        <span className="font-mono text-xs text-white/40">Sistemas que impulsionam negócios.</span>
      </div>
    </div>
  </footer>
);
